import { render } from "./ModalChoicePriceSchedules.vue?vue&type=template&id=2f33abd6&scoped=true"
import script from "./ModalChoicePriceSchedules.vue?vue&type=script&lang=js"
export * from "./ModalChoicePriceSchedules.vue?vue&type=script&lang=js"

import "./ModalChoicePriceSchedules.vue?vue&type=style&index=0&id=2f33abd6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f33abd6"]])

export default __exports__